import React, { useState, useEffect } from "react";
import { Button, Row, Col, Table } from "react-bootstrap";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import RowCountLabel from "./RowCountLabel";
import ApiManager from "../utils/ApiManager";
import ModalMoveProducts from "./ModalMoveProducts";
import ProductSearch from "./ProductSearch";
import ProductLink from "./ProductLink";
import DataManager from "../utils/DataManager";
import CheckBoxComponent from "./CheckBoxComponent";

const Products = () => {
  const [data, setData] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState("");
  const [showModal, setShowModal] = useState(false);

  const handleCheckedChange = (list) => {
    if (list.length > 0) {
      const updatedMovements = data.map((movement) => {
        const listItem = list.find((pl) => pl.id === movement.id);

        if (listItem) {
          const selected = listItem.selected;
          return {
            ...movement,
            selected: selected,
          };
        }

        return movement;
      });

      setData(updatedMovements);
    }
  };

  const fetchData = () => {
    if (selectedProductId) {
      ApiManager.Top.cellProducts(
        { productId: selectedProductId },
        (data) => {
          setData(data);
        },
        (error) => {
          console.error("Error fetching cell-products:", error);
        },
        () => {}
      );
    } else {
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProductId]);

  const handleProductChanged = (product) => {
    setSelectedProductId(product?.id);
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleSaveModal = () => {
    fetchData(); // Refresh data after modal save
  };

  const handleCheckboxChange = (rowId) => {
    const updatedRows = data.map((row) =>
      row.id === rowId ? { ...row, selected: !row.selected } : row
    );
    setData(updatedRows);
  };

  return (
    <div className="products">
      <ProductSearch
        onlyInStock={true}
        onProductChanged={handleProductChanged}
      />
      <Row className="mb-3">
        <Col>
          <RowCountLabel
            count={data?.length}
            label="Ubicazioni"
            htmlFor="productSelect"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col className="text-end">
          <Button
            onClick={handleOpenModal}
            variant="primary"
            className="float-end"
            title="Sposta"
            disabled={
              data?.filter((movement) => movement.selected).length === 0
            }
          >
            <MoveUpIcon />
          </Button>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <RowCountLabel count={data?.length} label="Ubicazioni" />
          <Table striped>
            <thead>
              <tr>
                <th style={{ width: "64px" }}></th>
                <th>Articolo</th>
                <th>Fornitore</th>
                <th className="text-end" style={{ width: "100px" }}>
                  Anno
                </th>
                <th className="text-end" style={{ width: "170px" }}>
                  Qta
                </th>
                <th>Ubicazione</th>
              </tr>
            </thead>
            <tbody>
              {data
                // ?.filter((row) => row.selected)
                ?.map((row, rowIndex) => (
                  <React.Fragment key={`row-${row.id}`}>
                    <tr style={{ verticalAlign: "middle", fontWeight: "bold" }}>
                    <td className="text-center">
                          <CheckBoxComponent
                            id={`qty-${row.id}`}
                            checked={row.selected}
                            onChange={() => handleCheckboxChange(row.id)}
                          />
                        </td>
                      <td>
                        <ProductLink {...row} showProductLink={false} />
                      </td>
                      <td>
                        <ul className="list-unstyled">
                          <li>{row.supplierDescr}</li>
                          <li>
                            <span className="half-parent-text">
                              {row.supplierId}
                            </span>
                          </li>
                        </ul>
                      </td>
                      <td className="text-end">{row.productYear}</td>
                      <td className="text-end">
                        {DataManager.Decimal.format(row.qty, 0)}
                      </td>
                      <td>
                        <a
                          href={`/celle?warehouseAreaId=${row.warehouseAreaId}&rack=${row.rack}&col=${row.col}&shelf=${row.shelf}`}
                        >
                          {`${row.warehouseAreaDescr}-${row.rack}-${row.col}-${row.shelf}`}
                          {row.lastMovData && (
                            <div className="half-parent-text">
                              {`Ult. mov. ${row.lastMovData}`}
                            </div>
                          )}
                        </a>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
            </tbody>
          </Table>
        </Col>
      </Row>
      <ModalMoveProducts
        movements={data}
        onCheckedChange={handleCheckedChange}
        showModal={showModal}
        setShowModal={setShowModal}
        onSaveModal={handleSaveModal}
      />
    </div>
  );
};

export default Products;
